<template>
	<sf-data-table
		ref="grpTable"
		:paging="false"
		:excel="isButton_(scrId, 'EX')"
		:columns="cols"
		:rows="rows"
		:stripe="false"
		:selection="false"
		:span-method="spanMethod"
	>
		<template v-slot:customRows="slotProps">
			<template v-for="(item, index) in monthlabel">
				<template v-if="slotProps.column.property === item">
					<td :key="index" class="col-1" style="all: unset; text-align: right">
						<!-- style="all: unset; cursor: pointer; text-align: right"
						@click="onGoClick(slotProps.row[slotProps.column.property], slotProps)" -->
						{{ slotProps.row[slotProps.column.property] }}
					</td>
				</template>
			</template>
		</template>
	</sf-data-table>
</template>

<script>
import { rootComputed } from '@/store/common/helpers'; //공통
import { serviceComputed, serviceMethods } from '@mqy/clma/PcRsNum/store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			monthlabel: '',
			cuRslt: '',
			bfRslt: ''
		};
	},
	created() {
		this.monthlabel = this.monthlabel_;
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			return this.grdSalesList;
		},
		cols() {
			return this.dayCols_;
		}
	},
	methods: {
		...serviceMethods,
		resetTable() {
			this.$emit('Refresh');
		},
		spanMethod({ row, column, rowIndex, columnIndex }) {
			if (columnIndex === 0) {
				if (rowIndex % 5 === 0) {
					return {
						rowspan: 5,
						colspan: 1
					};
				} else {
					return {
						rowspan: 0,
						colspan: 0
					};
				}
			}
		}
	}
};
</script>

<style></style>
